<template>
  <el-container class="NotificationsList">

    <el-header class="NotificationsList-header" height="40px">
      <h3>{{ $t("Changer d'utilisateur") }}</h3>
    </el-header>
    <div style="margin-bottom: 20px;">En tant qu'administrateur du compte, vous pouvez <br> accéder à l'Espace des autres utilisateurs du compte. </div>

    <el-main class="NotificationsList-notifications">

      <p class="mb-4" v-if="!users || users.total === 0">
        {{ $t("Aucun autres utilisateur") }}
      </p>
      <el-table v-else :data="users.list" :show-header="false">
        <el-table-column>
          <template v-slot="{ row: user }">
            <div @click="switchUser(user.username)" class="NotificationsList-message">
              <p class="mb-0">
                <strong>{{user.fullname}}</strong> / {{ user.username }}
              </p>

<!--              <el-button-->
<!--                class="NotificationsList-unread"-->
<!--                icon="check"-->
<!--                size="mini"-->
<!--                type="success"-->
<!--              ></el-button>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>

<script>

import { mapGetters } from 'vuex'
import { getUsers } from '@/services/users'
import { getSwitchedToken } from '@/services/auth'
const jwtDecode = require('jwt-decode')

export default {
  name: 'SwitchUserList',
  computed: {
    ...mapGetters(['isMainAccount', 'isSubAdmin']),
    decodedToken () {
      return jwtDecode(this.$store.getters.getToken)
    }
  },
  data () {
    return {
      users: {}
    }
  },
  methods: {
    async switchUser (username) {
      this.$confirm("Vous allez être redirigé sur l'Espace Client d'un collaborateur rattaché à votre compte.", 'Attention')
        .then(async () => {
          const switchedToken = await getSwitchedToken(username)
          await this.$router.push({ name: 'login', params: { token: switchedToken } })
        }).catch(() => {
        })
    }
  },
  async created () {
    if (this.isMainAccount) {
      this.users = await getUsers({ active: true, pagination: false, roles: ['ROLE_SUB_ADMIN', 'ROLE_SUB_USER'] })
    } else if (this.isSubAdmin) {
      this.users = await getUsers({ active: true, pagination: false, roles: 'ROLE_SUB_USER' })
    }

    if (this.decodedToken.switchedFromUser) {
      const switchedUser = await getUsers({ username: this.decodedToken.switchedFromUser })
      if (switchedUser.total > 0) {
        if (!this.users.total) {
          this.users.list = []
          this.users.total = 0
        }

        let userAlreadyExist = false
        const self = this
        this.users.list.forEach(function (user) {
          if (user.username === this.decodedToken.switchedFromUser) {
            userAlreadyExist = true
          }
        }, self)

        if (!userAlreadyExist) {
          this.users.list.push(switchedUser.list[0])
          this.users.total++
          this.$forceUpdate()
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.fulljustify {
  text-align:justify;
}
.fulljustify:after {
  content: "";
  display: inline-block;
  width: 100%;
}
#tagline {
  height: 80px;
  overflow: hidden;
  line-height: 80px; /* vert-center */
}

.NotificationsList {
  max-height: 80vh;
  overflow: visible;

  &-unreadAll {
    position: absolute;
    right: 10px;
    top: map-get($spacers, 3);
  }

  &-unread {
    @extend .ml-2;
  }

  &-message {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  &-notifications {
    margin: 0 map-get($spacers, 4) * -1 map-get($spacers, 4) * -1
      map-get($spacers, 4) * -1 !important;
  }

  @include media-breakpoint-down(sm) {
    max-height: 50vh;
  }
}
</style>
